import { API } from '../api';
import axiosInstance from '../axiosConfig';

export const addPatientApi = async (body) => {
  const response = await axiosInstance.post(API.PATIENTS.ADD_PATIENT, body);
  return response.data;
};

export const addTempPatient = async (body) => {
  const response = await axiosInstance.post(API.PATIENTS.TEMP_PATIENT, body);
  return response.data;
};

export const updatePatientApi = async (body) => {
  const response = await axiosInstance.patch(API.PATIENTS.UPDATE_PATIENT, body);
  return response;
};

export const getPatientApi = async (id) => {
  const response = await axiosInstance.get(`${API.PATIENTS.GET_PATIENT}${id}`);
  return response.data;
};
export const getSerilizedPatients = async (locationId, page, perPage) => {
  const response = await axiosInstance.get(
    `${API.PATIENTS.PAGINATION_PATIENTS}?locationId=${locationId}&page=${page}&perPage=${perPage}`
  );
  return response;
};

export const searchPatient = async (body) => {
  const response = await axiosInstance.post(API.PATIENTS.PAGINATION_SEARCH, body);
  return response;
};
export const getPatientByIdApi = async (id, locationId) => {
  const response = await axiosInstance.get(`${API.PATIENTS.GET_PATIENT_BY_ID}${id}/${locationId}`);
  return response.data;
};

export const deletePatientApi = async (id) => {
  const response = await axiosInstance.delete(`${API.PATIENTS.DELETE_PATIENT}${id}`);
  return response.data;
};

export const addNotes = async (body) => {
  const response = await axiosInstance.post(`${API.PATIENTS.ADD_NOTES}`, body);
  return response;
};

export const getNotesByAppointmnetId = async (id) => {
  const response = await axiosInstance.get(`${API.PATIENTS.APPOINTMENTS_NOTES}${id}`);
  return response;
};

export const getNotesByCustomerId = async (id, locationId) => {
  const response = await axiosInstance.get(
    `${API.PATIENTS.CUSTOMER_NOTES}${id}?locationId=${locationId}`
  );
  return response;
};

export const deleteNotes = async (id) => {
  const response = await axiosInstance.delete(`${API.PATIENTS.DELETE_NOTES}${id}`);
  return response;
};

export const updateNotes = async (body) => {
  const response = await axiosInstance.patch(`${API.PATIENTS.UPDATE_NOTES}`, body);
  return response;
};
export const getConversationLogs = async (id, locationId) => {
  const response = await axiosInstance.get(
    `${API.PATIENTS.CONVERSTAION_LOGS}${id}?locationId=${locationId}`
  );
  return response;
};
